import React, { useEffect, useState } from 'react';
import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import { ApiClient } from '../../api_client';
import './suggestions.css'
import Loader from '../loader/loader';
import { useSelector } from 'react-redux';
import { getUser } from '../../store/user.reducer';
import { AUTOMATION_TOPICS } from '../../constants';

const Suggestions = ({updateFormData}: { updateFormData: CallableFunction }) => {

  const [pending, setPending]: any = useState(true);
  const [suggestions, setSuggestions]: any = useState(null);
  const [selectedSuggestion, setSelectedSuggestion]: any = useState(null);

  const user = useSelector(getUser);

  useEffect(() => {
    fetchPostSuggestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchPostSuggestions = async () => {
    setPending(true);
    ApiClient.getPostSuggestions((user.automationTopics.length > 0 ? user.automationTopics : AUTOMATION_TOPICS).join(','))
      .then(response => {
        setSuggestions(response.data)
      })
      .catch(e => {
        setSuggestions([]);
      })
      .finally(() => {
        setPending(false);
      })
  }

  const handleSelectSuggestion = (post: Object, index: number) => {
    setSelectedSuggestion(index);
    updateFormData(post);
  }

  const render = () => {
    const renderer: any = [];

    suggestions?.forEach((post: any, index: number) => {
      renderer.push(
        <MDBRow className="mb-2" key={index}>
          <MDBCol>
            <span className={`suggestion-title ${index === selectedSuggestion && 'selected'}`}
                  onClick={() => handleSelectSuggestion(post, index)}>
            {post.title}
            </span>
          </MDBCol>
        </MDBRow>
      )
    });

    return renderer;
  }

  return (
    <>
      <h4 className="mt-4 mb-4">
        Post suggestions
      </h4>
      <div className="suggestions" style={pending ? { height: 320 + 'px'} : {}}>
        <Loader isVisible={pending} messageType="default" />
        {render()}
      </div>
    </>
  )

}

export default Suggestions;
